// ModalAnswer.jsx
import React from 'react';
import { Modal } from 'react-bootstrap';

const ModalAnswer = ({ show, onClose, headerMessage, children }) => {
    return (
        <Modal show={show} onHide={onClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{headerMessage}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {children}
            </Modal.Body>
        </Modal>
    );
};

export default ModalAnswer;